import { applyMiddleware, createStore, compose } from "redux";
import { createEpicMiddleware } from "redux-observable";
import thunk from "redux-thunk";
import rootReducer from "./state_management/reducers";
import { StateLoader } from "./state_management";
import * as actionCreators from "./state_management/actions/index";
import { composeWithDevTools } from "@redux-devtools/extension";
import { getMode } from "./settings";

export type stateType = Exclude<Parameters<typeof rootReducer>[0], undefined>;

const epicMiddleware = createEpicMiddleware();
const stateLoader = new StateLoader();
const initialState = stateLoader.loadState();

const composeEnhancers = composeWithDevTools(
  getMode() === "production"
    ? {}
    : {
        actionCreators,
        trace: true,
        traceLimit: 25
      }
);

const middleware = [epicMiddleware, thunk];
export const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

store.subscribe(() => {
  stateLoader.saveState(store.getState(), [
    "commonReloadReducer"
  ]);
});
